import { connect } from 'react-redux';
import PageTemplate from './PageTemplate';
import { getTemplateProps } from './utils';
import { getEventTitle } from '../../selectors/event';

export default connect((state) => ({
    templateProps: getTemplateProps({ state }),
    title: getEventTitle(state),
}))(PageTemplate);
